export const ObjectTypes = {
    Table: 1,
    View: 2,
    Index: 3,
    Trigger: 4,
    Procedure: 5,
    Function: 6,
    Unknown: 0,
}   